module.exports = __webpack_public_path__ + "media/images/icon_plus_lightgreen-e5156bae161bf2649b84021ca568ab39.svg";